import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=5e8d433c&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=5e8d433c&prod&lang=scss"
import style1 from "./IndexView.vue?vue&type=style&index=1&id=5e8d433c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d433c",
  null
  
)

export default component.exports